import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import languageContext from "../context/language/languageContext";
import Navbar from "../components/Navbar";
import { Calendar, Clock, CheckCircle, XCircle } from "lucide-react";

const ViewReminderReport = () => {
  const { setAlert, setMessage, setSessionTimeout } = useContext(languageContext);
  const [reminders, setReminders] = useState([]);


  const location = useLocation();

  const fetchReminders = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;

    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/doctor_create_report_excel",
        JSON.stringify({ patient_id: patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setReminders(response.data.data || []);
      }
    } catch (error) {
      if (error.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        setAlert(true);
        setMessage("Failed to fetch reminders. Try again later.");
        console.error(error);
      }
    }
  };

  useEffect(() => {
    fetchReminders()
  }, []);

  const formatResponseStatus = (status) => {
    console.log(status)
    if (status === "true" || status === true) return { text: "Taken", className: "bg-green-100 text-green-700" };
    if (status === "false" || status === false) return { text: "Missed", className: "bg-red-100 text-red-700" };
    return { text: "Pending", className: "bg-yellow-100 text-yellow-800" };
  };


    return (
      <div className="flex flex-col h-screen bg-gradient-to-br from-blue-50 to-white">
        <Navbar />
    
        <div className="flex flex-col flex-grow max-w-6xl mx-auto w-full px-4 pt-24 pb-4">
          <h2 className="text-3xl font-bold text-blue-800 text-center mb-4">
            ⏰ Reminder Report
          </h2>
    
          <div className="flex-grow overflow-y-auto rounded-xl p-2">
            {reminders.length === 0 ? (
              <div className="text-center text-gray-600 text-lg italic py-10">
                No reminders available.
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {reminders.map((reminder, index) => {
                  const { text, className } = formatResponseStatus(reminder.pill_reponse);
                  return (
                    <div
                      key={index}
                      className="bg-white rounded-xl p-4 shadow hover:shadow-lg transition duration-200 border border-blue-100"
                    >
                      <div className="flex items-center gap-2 mb-2">
                        <Calendar className="text-blue-600 w-5 h-5" />
                        <span className="text-blue-900 font-medium text-sm">
                          {new Date(reminder.date).toLocaleDateString()}
                        </span>
                      </div>
    
                      <div className="flex items-center text-gray-600 text-sm mb-1">
                        <Clock className="w-4 h-4 mr-2" />
                        {reminder.time}
                      </div>
    
                      <div className="text-gray-500 text-sm mb-2">{reminder.weekday}</div>
    
                      <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${className}`}>
                        {text}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    );
    
};

export default ViewReminderReport;
